<script>
    import * as billingService from './service.js';
    import BreadCrumNav from '../../components/breadcrum-nav.svelte';
    import List from "./_components/v2-list.svelte";
    import workspaceService from '../../services/workspace.js';
    import { searchAssetsCountByKind } from '../asset/assets.state.svelte.js';
    import { workspacePlan } from '../user/user.state.svelte.js';
    import { format, locale } from 'svelte-i18n';
    import { notificate } from '../../services/notification';
    import dayjs from 'dayjs';
    import relativeTime from 'dayjs/plugin/relativeTime';
    import localizedFormat from 'dayjs/plugin/localizedFormat';
    import 'dayjs/locale/es';
    import 'dayjs/locale/en';


    dayjs.locale($locale);
    dayjs.extend(relativeTime);
    dayjs.extend(localizedFormat);

    let billing;
    let workspace;
    let assetsCount;
    let assetsInScopeCount;

    const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
    ];

    let month_selected;
    const month = dayjs().month();
    const current_year = dayjs().year();
    let year = current_year;
    let value = $state(months[month]);

    let billingPromise = billingService.search({}, current_year, month);
    let assetsCountPromise = searchAssetsCountByKind('v2/asset/count_by_kind/', {});
    let assetsCountInScopePromise = searchAssetsCountByKind('v2/asset/count_by_kind/', {filter: {in_scope: true}});
    let workspacePromise = workspaceService.search();

    let public_ips_diff = $state();
    let public_networks_diff = $state();
    let domains_diff = $state();
    let ad_diff = $state();
    let private_ips_diff = $state();
    let private_networks_diff = $state();
    let emails_diff = $state();
    let software_diff = $state();
    let cloud_diff = $state();
    let endpoint_diff = $state();

    let public_ips_progress_class = $state();
    let public_networks_progress_class = $state();
    let domains_progress_class = $state();
    let ad_progress_class = $state();
    let private_ips_progress_class = $state();
    let private_networks_progress_class = $state();
    let emails_progress_class = $state();
    let software_progress_class = $state();
    let cloud_progress_class = $state();
    let endpoint_progress_class = $state();

    const concepts = {
        ip: "IP pública",
        private_ip: "IP privada",
    }

    const sortData = (billingData)=>{
        return billingData.sort((a,b)=> b.concept.localeCompare(a.concept));
    }

    const reorderMonths = (values) => {
        let last_portion = values.splice(dayjs().month()+1);
        last_portion.reverse();
        values.reverse();
        return values = values.concat(last_portion);
    }

    const selectMonth = (e)=>{
        let idx = months.findIndex(m=> m == e.target.value);
        if(idx > dayjs().month()) {
            year--;
        }
        handleTableRefresh({detail:{month: idx, year: year}});
    }

    let allPromises = $state(Promise.all([billingPromise, assetsCountPromise, assetsCountInScopePromise, workspacePromise])
        .then(([pBilling, pAssetsCount, pAssetInScopeCount, pWorkspace])=>{

            billing = pBilling;
            assetsCount = pAssetsCount;
            assetsInScopeCount = pAssetInScopeCount;
            workspace = pWorkspace;
            let data = [];

            for(let [key, value] of Object.entries(billing.concepts)){
                if(key != "flat_rate"){
                    let flat_rate_per_day = value.base_price/dayjs().daysInMonth();
                    let days_used = Math.round(value.amount/flat_rate_per_day);
                    for(let kv of Object.entries(value.entries)){
                        if(kv[1].count > 0){
                            data.push(
                                {
                                    date   : dayjs(kv[0]).format("YYYY/MM/DD"),
                                    concept: concepts[key],
                                    count  : kv[1].count,
                                    amount : kv[1].amount
                                }
                            );
                        }
                    }
                }
            }
            public_ips_diff = calculateLimitsPercentages(workspace.ip_limit, assetsInScopeCount.public_ip);
            public_networks_diff = calculateLimitsPercentages(workspace.network_limit, assetsInScopeCount.public_network);
            domains_diff = calculateLimitsPercentages(workspace.domain_limit, assetsInScopeCount.domain);
            ad_diff = calculateLimitsPercentages(workspace.active_directory_limit, assetsInScopeCount["ad"]);
            private_ips_diff = calculateLimitsPercentages(workspace.private_ip_limit, assetsInScopeCount.private_ip);
            private_networks_diff = calculateLimitsPercentages(workspace.private_network_limit, assetsInScopeCount.private_network);
            emails_diff = calculateLimitsPercentages(workspace.email_limit, assetsInScopeCount["email"]);
            software_diff = calculateLimitsPercentages(workspace.source_code_limit, assetsInScopeCount["software"]);
            endpoint_diff = calculateLimitsPercentages(workspace.endpoint_limit, assetsInScopeCount["endpoint"]);
            cloud_diff = calculateLimitsPercentages(workspace.cloud_limit, assetsInScopeCount["cloud"]);

            if(public_ips_diff <= 99) {
                public_ips_progress_class = 'bg-dark-gray';
            }

            if(public_ips_diff > 99) {
                public_ips_progress_class = 'bg-danger';
            }

            if(public_networks_diff <= 99) {
                public_networks_progress_class = 'bg-dark-gray';
            }

            if(public_networks_diff > 99) {
                public_networks_progress_class = 'bg-danger';
            }

            if(domains_diff <= 99) {
                domains_progress_class = 'bg-dark-gray';
            }

            if(domains_diff > 99) {
                domains_progress_class = 'bg-danger';
            }

            if(ad_diff <= 99) {
                ad_progress_class = 'bg-dark-gray';
            }

            if(ad_diff > 99) {
                ad_progress_class = 'bg-danger';
            }

            if(private_ips_diff <= 99) {
                private_ips_progress_class = 'bg-dark-gray';
            }

            if(private_ips_diff > 99) {
                private_ips_progress_class = 'bg-danger';
            }

            if(private_networks_diff <= 99) {
                private_networks_progress_class = 'bg-dark-gray';
            }

            if(private_networks_diff > 99) {
                private_networks_progress_class = 'bg-danger';
            }

            if(emails_diff <= 99) {
                emails_progress_class = 'bg-dark-gray';
            }

            if(emails_diff > 99) {
                emails_progress_class = 'bg-danger';
            }

            if(software_diff <= 99) {
                software_progress_class = 'bg-dark-gray';
            }

            if(software_diff > 99) {
                software_progress_class = 'bg-danger';
            }

            if(endpoint_diff <= 99) {
                endpoint_progress_class = 'bg-dark-gray';
            }

            if(endpoint_diff > 99) {
                endpoint_progress_class = 'bg-danger';
            }

            if(cloud_diff <= 99) {
                cloud_progress_class = 'bg-dark-gray';
            }

            if(cloud_diff > 99) {
                cloud_progress_class = 'bg-danger';
            }

            return {
                billing: billing,
                assetsCount: assetsCount,
                assetsInScopeCount: assetsInScopeCount,
                workspace: workspace,
                data: sortData(data)
            }
        })
        .catch(e=>{
            return {
                billing : [],
                assetsCount : {},
                assetsInScopeCount: {},
                workspace: [],
                data: []
            }
        }))
    ;

    const calculateLimitsPercentages = (limit, count) => {
        if(!count) count = 0;
        let percentage = (count/limit)*100;
        return percentage;
    }

    const handleTableRefresh = (e) => {
        let year;

        if(e && e.detail){
            year  = e.detail.year;
            month_selected = e.detail.month;
        }

        if(!month_selected || month_selected < 0) month_selected = month;


        billingPromise = billingService.search({}, year, month_selected);
        workspacePromise = workspaceService.search();
        assetsCountPromise = searchAssetsCountByKind('v2/asset/count_by_kind/', {});
        assetsCountInScopePromise = searchAssetsCountByKind('v2/asset/count_by_kind/', {filter: {in_scope: true}});

        allPromises = Promise.all([billingPromise, assetsCountPromise, assetsCountInScopePromise, workspacePromise])
        .then(([pBilling, pAssetsCount, pAssetInScopeCount, pWorkspace])=>{
            billing = pBilling;
            assetsCount = pAssetsCount;
            assetsInScopeCount = pAssetInScopeCount;
            workspace = pWorkspace;
            let data = [];

            for(let [key, value] of Object.entries(billing.concepts)){
                if(key != "flat_rate"){
                    let flat_rate_per_day = value.base_price/dayjs().daysInMonth();
                    let days_used = Math.round(value.amount/flat_rate_per_day);
                    for(let kv of Object.entries(value.entries)){
                        if(kv[1].count > 0){
                            data.push(
                                {
                                    date   : kv[0],
                                    concept: concepts[key],
                                    count  : kv[1].count,
                                    amount : kv[1].amount
                                }
                            );
                        }
                    }
                }
            }
            public_ips_diff = calculateLimitsPercentages(workspace.ip_limit, assetsInScopeCount.public_ip);
            public_networks_diff = calculateLimitsPercentages(workspace.network_limit, assetsInScopeCount.public_network);
            domains_diff = calculateLimitsPercentages(workspace.domain_limit, assetsInScopeCount.domain);
            ad_diff = calculateLimitsPercentages(workspace.active_directory_limit, assetsInScopeCount["ad"]);
            private_ips_diff = calculateLimitsPercentages(workspace.ip_limit, assetsInScopeCount.private_ip);
            private_networks_diff = calculateLimitsPercentages(workspace.network_limit, assetsInScopeCount.private_network);
            emails_diff = calculateLimitsPercentages(workspace.active_directory_limit, assetsInScopeCount["email"]);
            software_diff = calculateLimitsPercentages(workspace.active_directory_limit, assetsInScopeCount["software"]);
            endpoint_diff = calculateLimitsPercentages(workspace.active_directory_limit, assetsInScopeCount["endpoint"]);
            cloud_diff = calculateLimitsPercentages(workspace.active_directory_limit, assetsInScopeCount["cloud"]);

            if(public_ips_diff <= 99) {
                public_ips_progress_class = 'bg-dark-gray';
            }

            if(public_ips_diff > 99) {
                public_ips_progress_class = 'bg-danger';
            }

            if(public_networks_diff <= 99) {
                public_networks_progress_class = 'bg-dark-gray';
            }

            if(public_networks_diff > 99) {
                public_networks_progress_class = 'bg-danger';
            }

            if(domains_diff <= 99) {
                domains_progress_class = 'bg-dark-gray';
            }

            if(domains_diff > 99) {
                domains_progress_class = 'bg-danger';
            }

            if(ad_diff <= 99) {
                ad_progress_class = 'bg-dark-gray';
            }

            if(ad_diff > 99) {
                ad_progress_class = 'bg-danger';
            }

            if(private_ips_diff <= 99) {
                private_ips_progress_class = 'bg-dark-gray';
            }

            if(private_ips_diff > 99) {
                private_ips_progress_class = 'bg-danger';
            }

            if(private_networks_diff <= 99) {
                private_networks_progress_class = 'bg-dark-gray';
            }

            if(private_networks_diff > 99) {
                private_networks_progress_class = 'bg-danger';
            }

            if(emails_diff <= 99) {
                emails_progress_class = 'bg-dark-gray';
            }

            if(emails_diff > 99) {
                emails_progress_class = 'bg-danger';
            }

            if(software_diff <= 99) {
                software_progress_class = 'bg-dark-gray';
            }

            if(software_diff > 99) {
                software_progress_class = 'bg-danger';
            }

            if(endpoint_diff <= 99) {
                endpoint_progress_class = 'bg-dark-gray';
            }

            if(endpoint_diff > 99) {
                endpoint_progress_class = 'bg-danger';
            }

            if(cloud_diff <= 99) {
                cloud_progress_class = 'bg-dark-gray';
            }

            if(cloud_diff > 99) {
                cloud_progress_class = 'bg-danger';
            }

            return {
                billing: billing,
                assetsCount: assetsCount,
                assetsInScopeCount: assetsInScopeCount,
                workspace: workspace,
                data: sortData(data)
            }
        })
        .catch(e=>{
            return {
                billing : [],
                assetsCount : {},
                assetsInScopeCount: {},
                workspace: [],
                data: []
            }
            })
        ;
    }

    const updateDataFromAWS = () => {
        billingService.updateFromAWS()
            .then((r)=>{
                    notificate("aws_sync_ok")
                    return handleTableRefresh({detail:{year: current_year}})
                })
                .catch(error=>{
                    return notificate("500");
                })
            ;
    }
</script>
<style>

    hr {
        margin-top: 0.5rem !important;
        margin-bottom: 2rem;
    }
    .billing-value{
        float: right;
    }
    .info-box-text{
        font-size: 1rem;
    }
    .info-box-concept {
        font-size: 1.1rem;
    }
    .small-box p {
        font-size: 0.9rem;
    }
    .bg-dark-gray {
        background: #807c7c;
    }
</style>

<section class="content-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <h1 class="mt-3 mb-3 page-title">
                    <i class="fas fa-file-invoice-dollar"></i>
                   {$format("page.billing.title")}
                </h1>
            </div>
            <div class="col-6">
                <BreadCrumNav routes={[{ label: $format("page.billing.title") }]} />
            </div>
        </div>
    </div>
</section>

<section class="content">
    <div class="container-fluid">
        {#if workspacePlan.data != "aws"}
            <div class="row">
                <div class="col-4">
                    <a href="/asset/public_ip" style="text-decoration: none; color: rgb(33, 37, 41) !important;">
                        <div class="small-box bg-white">
                            <div class="inner">
                                {#await allPromises then data}
                                    <h3>{data.assetsCount["public_ip"] || 0}/{data.assetsInScopeCount["public_ip"] || 0}</h3>
                                {/await}
                                <p>{$format("asset.kind.public_ip.plural")} {$format("page.billing.billable_ips")}</p>
                            </div>
                            {#await allPromises then data}
                                <div class="icon">
                                    <i class="fas fa-laptop"></i>
                                </div>
                            {/await}
                            {#await allPromises}
                                <div class="overlay">
                                    <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                                </div>
                            {/await}
                        </div>
                    </a>
                </div>
                <div class="col-4">
                    <div class="small-box bg-white">
                        <div class="inner">
                            {#await allPromises then data}
                                <h3>{data.billing.total.toFixed(2)} USD</h3>
                            {/await}
                            <p>{$format("page.billing.consumption_to_date")}</p>
                        </div>
                        {#await allPromises then data}
                            <div class="icon">
                                <i class="fas fa-dollar-sign"></i>
                            </div>
                        {/await}
                        {#await allPromises}
                            <div class="overlay">
                                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                            </div>
                        {/await}
                    </div>
                </div>

                <div class="col-4">
                    <div class="small-box bg-white">
                        <div class="inner">
                            {#await allPromises then data}
                                <h3>{dayjs().format("YYYY/MM/DD")}</h3>
                            {/await}
                            <p>{$format("page.billing.date")}</p>
                        </div>
                        {#await allPromises then data}
                            <div class="icon">
                                <i class="fas fa-calendar-day"></i>
                            </div>
                        {/await}
                        {#await allPromises}
                            <div class="overlay">
                                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                            </div>
                        {/await}
                    </div>
                </div>
            </div>
        {/if}
        {#await allPromises then data}
            <div class="row">
                <div class="col-12 d-flex"><h3>{$format("page.billing.limits.title")}</h3> <i class="ms-2 mt-2 fas fa-question-circle" title="Esta cuenta posee límites para agregar activos. Si desea aumentarlos, por favor, envíe un mail a vulseek@securetia.com."></i></div>
            </div>
            <div class="row">
                <div class="col d-flex">
                    <div class="small-box bg-white mb-0 w-100 d-flex">
                        <div class="inner d-flex flex-column justify-content-between w-100">
                            <div>{data.assetsInScopeCount.public_ip || 0} <strong>{data.assetsInScopeCount.public_ip == 1 ? $format("asset.kind.public_ip.singular").toLowerCase() : $format("asset.kind.public_ip.plural").toLowerCase() }</strong> {$format("of")} {data.workspace.ip_limit} {$format("available")}</div>
                            <div class="progress mt-2">
                                <div class="{'progress-bar ' + public_ips_progress_class}" role="progressbar" style="{'width:'+ public_ips_diff +'%'}" aria-valuenow="{public_ips_diff}" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                        </div>
                    </div>
                </div>
                <div class="col d-flex">
                    <div class="small-box bg-white mb-0 w-100 d-flex">
                        <div class="inner d-flex flex-column justify-content-between w-100">
                            <div>{data.assetsInScopeCount.public_network || 0} <strong>{data.assetsInScopeCount.public_network == 1 ? $format("asset.kind.public_network.singular").toLowerCase() : $format("asset.kind.public_network.plural").toLowerCase() }</strong> {$format("of")} {data.workspace.network_limit} {$format("available")}</div>
                            <div class="progress mt-2">
                                <div class="{'progress-bar ' + public_networks_progress_class}" role="progressbar" style="{'width:'+ public_networks_diff +'%'}" aria-valuenow="{public_networks_diff}" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                        </div>
                    </div>
                </div>
                <div class="col d-flex">
                    <div class="small-box bg-white mb-0 w-100 d-flex">
                        <div class="inner d-flex flex-column justify-content-between w-100">
                            <div>{data.assetsInScopeCount.domain || 0} <strong>{data.assetsInScopeCount.domain == 1 ? $format("asset.kind.domain.singular").toLowerCase() : $format("asset.kind.domain.plural").toLowerCase() }</strong> {$format("of")} {data.workspace.domain_limit || 0} {$format("available")} </div>
                            <div class="progress mt-2">
                                <div class="{'progress-bar ' + domains_progress_class}" role="progressbar" style="{'width:'+ domains_diff +'%'}" aria-valuenow="{domains_diff}" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                        </div>
                    </div>
                </div>
                <div class="col d-flex">
                    <div class="small-box bg-white mb-0 w-100 d-flex">
                        <div class="inner d-flex flex-column justify-content-between w-100">
                            <div>{data.assetsInScopeCount.email || 0} <strong>{data.assetsInScopeCount.email == 1 ? "email" : "emails" }</strong> {$format("of")} {data.workspace.email_limit || 0} {$format("available")} </div>
                            <div class="progress mt-2">
                                <div class="{'progress-bar ' + emails_progress_class}" role="progressbar" style="{'width:'+ emails_diff +'%'}" aria-valuenow="{emails_diff}" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                        </div>
                    </div>
                </div>

                <div class="col d-flex">
                    <div class="small-box bg-white mb-0 w-100 d-flex">
                        <div class="inner d-flex flex-column justify-content-between w-100">
                            <div>{data.assetsInScopeCount["ad"] || 0} <strong>{data.assetsInScopeCount["ad"] == 1 ? $format("asset.kind.ad.singular").toLowerCase() : $format("asset.kind.ad.plural").toLowerCase() }</strong> {$format("of")} {data.workspace.active_directory_limit || 0} {$format("available")} </div>
                            <div class="progress mt-2">
                                <div class="{'progress-bar ' + ad_progress_class}" role="progressbar" style="{'width:'+ ad_diff +'%'}" aria-valuenow="{ad_diff}" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row mt-3">
                <div class="col d-flex">
                    <div class="small-box bg-white mb-0 w-100 d-flex">
                        <div class="inner d-flex flex-column justify-content-between w-100">
                            <div>{data.assetsInScopeCount.private_ip || 0} <strong>{data.assetsInScopeCount.private_ip == 1 ? $format("asset.kind.private_ip.singular").toLowerCase() : $format("asset.kind.private_ip.plural").toLowerCase() }</strong> {$format("of")} {data.workspace.private_ip_limit} {$format("available")}</div>
                            <div class="progress mt-2">
                                <div class="{'progress-bar ' + private_ips_progress_class}" role="progressbar" style="{'width:'+ private_ips_diff +'%'}" aria-valuenow="{private_ips_diff}" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                        </div>
                    </div>
                </div>
                <div class="col d-flex">
                    <div class="small-box bg-white mb-0 w-100 d-flex">
                        <div class="inner d-flex flex-column justify-content-between w-100">
                            <div>{data.assetsInScopeCount.private_network || 0} <strong>{data.assetsInScopeCount.private_network == 1 ? $format("asset.kind.private_network.singular").toLowerCase() : $format("asset.kind.private_network.plural").toLowerCase() }</strong> {$format("of")} {data.workspace.private_network_limit} {$format("available")}</div>
                            <div class="progress mt-2">
                                <div class="{'progress-bar ' + private_networks_progress_class}" role="progressbar" style="{'width:'+ private_networks_diff +'%'}" aria-valuenow="{private_networks_diff}" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                        </div>
                    </div>
                </div>
                <div class="col d-flex">
                    <div class="small-box bg-white mb-0 w-100 d-flex">
                        <div class="inner d-flex flex-column justify-content-between w-100">
                            <div>{data.assetsInScopeCount.endpoint || 0} <strong>{data.assetsInScopeCount.endpoint == 1 ? $format("asset.kind.endpoint.singular").toLowerCase() : $format("asset.kind.endpoint.plural").toLowerCase() }</strong> {$format("of")} {data.workspace.endpoint_limit || 0} {$format("available")} </div>
                            <div class="progress mt-2">
                                <div class="{'progress-bar ' + endpoint_progress_class}" role="progressbar" style="{'width:'+ endpoint_diff +'%'}" aria-valuenow="{endpoint_diff}" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                        </div>
                    </div>
                </div>
                <div class="col d-flex">
                    <div class="small-box bg-white mb-0 w-100 d-flex">
                        <div class="inner d-flex flex-column justify-content-between w-100">
                            <div>{data.assetsInScopeCount.software || 0} <strong>{data.assetsInScopeCount.software == 1 ? $format("asset.kind.software.singular").toLowerCase() : $format("asset.kind.software.plural").toLowerCase() }</strong> {$format("of")} {data.workspace.source_code_limit || 0} {$format("available")} </div>
                            <div class="progress mt-2">
                                <div class="{'progress-bar ' + software_progress_class}" role="progressbar" style="{'width:'+ software_diff +'%'}" aria-valuenow="{software_diff}" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                        </div>
                    </div>
                </div>
                {#if data.workspace.cloud_limit > 0}
                    <div class="col d-flex">
                        <div class="small-box bg-white mb-0 w-100 d-flex">
                            <div class="inner d-flex flex-column justify-content-between w-100">
                                <div>{data.assetsInScopeCount["cloud"] || 0} <strong>{data.assetsInScopeCount["cloud"] == 1 ? $format("asset.kind.cloud.singular").toLowerCase() : $format("asset.kind.cloud.plural").toLowerCase() }</strong> {$format("of")} {data.workspace.active_directory_limit || 0} {$format("available")} </div>
                                <div class="progress mt-2">
                                    <div class="{'progress-bar ' + cloud_progress_class}" role="progressbar" style="{'width:'+ cloud_diff +'%'}" aria-valuenow="{cloud_diff}" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                {/if}
            </div>
        {/await}
        {#if workspacePlan.data != "aws"}
            <div class="row mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="card-title ps-3 pt-3">
                            <h3>Plan {workspacePlan.data.toUpperCase()}</h3>
                        </div>
                        <div class="card-body">
                            {#if workspacePlan.data == "premium"}
                                    <div>Para ver la información de facturación, por favor, contactate con tu asesor comercial enviando un correo electrónico a <a href="mailto:vulseek@securetia.com">vulseek@securetia.com</a>.</div>
                                {/if}

                            <div>{$format("page.billing.plan.text")}<a target="_blank" href="{$locale != 'es' ? "https://www.securetia.com" + `/${$locale}/vulseek` : "https://www.securetia.com/vulseek"}">{$locale != 'es' ? "https://www.securetia.com" + `/${$locale}/vulseek` : "https://www.securetia.com/vulseek"}</a>.</div>
                        </div>
                    </div>
                </div>
            </div>
        {:else}
            <div class="row mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="card-title ps-3 pt-3">
                            <h3>{$format("page.billing.plan.aws_title")}</h3>
                        </div>
                        <div class="card-body">
                            <p>{$format("page.billing.plan.aws_p1")}</p>
                            <p>{@html $format("page.billing.plan.aws_p2")}</p>
                            <p>{@html $format("page.billing.plan.aws_p3")}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <p>{$format("page.billing.plan.aws_update_data")}</p>
                            <p><button class="btn btn-primary mt-3" onclick={updateDataFromAWS}>{$format("buttons.sync_aws")}</button></p>
                        </div>
                    </div>
                </div>
            </div>
        {/if}
        {#await allPromises then data}
            {#if workspacePlan.data != "free" && workspacePlan.data != "premium" && workspacePlan.data != "aws"}
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="card-title">
                                    Ver meses anteriores
                                </div>
                            </div>
                            <div class="card-body">
                                <select class="form-control w-25 mb-3" bind:value={value} oninput={(e)=>selectMonth(e)}>
                                    {#each reorderMonths([... months]) as item, index}
                                        <option value={item}>{item + " (" + ( index <= month ? current_year : current_year -1) + ")" }</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <List data={data.data} />
                {#if data.data.length > 0}
                    <div class="row">
                        <div class="card col-4 offset-8">
                            <div class="card-body">
                                {#if workspacePlan.data == "standard"}
                                    <div><strong>{$format("page.billing.plan_standard_fee")}*</strong>: <span class="billing-value">{data.billing.concepts.flat_rate.amount} USD</span></div>
                                {/if}
                                <div><strong>{$format("page.billing.subtotal")}</strong>: <span class="billing-value">{(data.billing.concepts["ip"].amount + data.billing.concepts["private_ip"].amount + (data.billing.concepts["flat_rate"] ? data.billing.concepts["flat_rate"].amount : 0)).toFixed(2)} USD</span></div>
                                <hr />
                                <div><strong>{$format("page.billing.total")}</strong>: <span class="billing-value">{data.billing.total.toFixed(2)} USD</span></div>
                            </div>
                        </div>
                        {#if workspacePlan.data == "standard"}
                            <div class="d-flex justify-content-end col-12 pb-3"><small>*{$format("page.billing.prorated")}</small></div>
                        {/if}
                    </div>
                {/if}
            {/if}
        {/await}
        {#await allPromises}
            <div class="overlay text-center">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
        {/await}
    </div>
</section>

